import React from "react";

const JsonContainer = ({ data }) => {
  return (
    <div className="container">
      {data.map((item, index) => (
        <div key={index} className="pl-[5%] pr-[5%]">
            <h4 className="mb-4">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[19px] text-[#6A0DAD] max-[768px]:text-[17px] font-bold"
                >
                  {item.name}
                </a>
            </h4>
          <p className="font-bold text-[18px] text-[#cc00ff] mb-4">{item.Year}</p>
          <p className="text-[1.1em] text-[#333] leading-[1.5] max-[768px]:text-[16px] mb-4" dangerouslySetInnerHTML={{__html: item.Content}}></p>
          <p>  
            <a
              href={item.linker}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[18px] font-bold text-[#b040b1] underline"
            >
              {item.Acesse}
            </a>
          </p>
          {item.remember && <p className="text-[14px] mt-4">{item.remember}</p>}
          <br/>
        </div>
      ))}
    </div>
  );
};

export default JsonContainer;